import { render, staticRenderFns } from "./settingsInformationBusiness.vue?vue&type=template&id=a2d963c0&scoped=true&"
import script from "./settingsInformationBusiness.vue?vue&type=script&lang=js&"
export * from "./settingsInformationBusiness.vue?vue&type=script&lang=js&"
import style0 from "./settingsInformationBusiness.vue?vue&type=style&index=0&id=a2d963c0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d963c0",
  null
  
)

export default component.exports